export default "__VITE_ASSET__BMo7vl1x__"